import { render, staticRenderFns } from "./yiDesign.vue?vue&type=template&id=61367d36&scoped=true&"
import script from "./yiDesign.vue?vue&type=script&lang=js&"
export * from "./yiDesign.vue?vue&type=script&lang=js&"
import style0 from "./yiDesign.vue?vue&type=style&index=0&id=61367d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61367d36",
  null
  
)

export default component.exports